import moment from "moment-timezone";
import { formatAddress } from "app/containers/Jobs/utils/format";

// Contract token values for one job, built the way the backend fills a sent
// contract (ContractAPI ContractService._collect_placeholder_data), so Job
// Setup's Contract Preview reads like the PDF the client will get.

// The backend hardcodes this too, until Job has a structured service type.
const SERVICE_TYPE = "Home Inspection";

// Backend: first appointment's start, strftime("%B %d, %Y").
const formatInspectionDate = (startTime) =>
  startTime ? moment(startTime.substring(0, 19)).format("MMMM DD, YYYY") : "";

// Backend: f"${job.quote}" on a 2-decimal field, so "$2000.00", never grouped.
const formatFee = (quote) => {
  if (quote === "" || quote === null || quote === undefined) return "";
  const amount = Number(quote);
  return Number.isFinite(amount) ? `$${amount.toFixed(2)}` : `$${quote}`;
};

/**
 * @param {{appointment: Object, quote: string|number|null}} args - the quote
 *   as currently typed in Job Setup, so the preview matches what Save sends
 * @returns {Object<string, string>} token → value; "" where the job has none
 */
export const buildJobContractData = ({ appointment, quote }) => {
  const job = appointment?.job || {};
  const client = job.report?.client || {};
  const address = formatAddress(job.report?.address);

  return {
    Client_Name: client.name || "",
    Client_Email: client.email || "",
    Property_Address: address,
    // Deprecated alias; pre-AS-816 cloned templates still carry it.
    Job_Address: address,
    Total_Fee: formatFee(quote),
    Inspection_Date: formatInspectionDate(appointment?.start_time),
    Service_Type: SERVICE_TYPE,
    Agent_Name: job.client_provided_agent_name || "",
  };
};
